var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { title: _vm.title, loading: _vm.loading } },
    [
      _vm.quotation
        ? _c("section", [
            _c("div", { staticClass: "level" }, [
              _c(
                "div",
                {
                  staticClass:
                    "level-item has-text-centered page-quotation__header-item"
                },
                [
                  _c("div", [
                    _c("p", { staticClass: "heading" }, [
                      _c("strong", [_vm._v("CEP de origem")])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "title is-6" }, [
                      _vm._v(
                        _vm._s(_vm._f("cep")(_vm.quotation.origin_zip_code))
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "level-item has-text-centered page-quotation__header-item"
                },
                [
                  _c("div", [
                    _c("p", { staticClass: "heading" }, [
                      _c("strong", [_vm._v("CEP de destino")])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "title is-6" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("cep")(_vm.quotation.destination_zip_code)
                        )
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "level-item has-text-centered page-quotation__header-item"
                },
                [
                  _c("div", [
                    _c("p", { staticClass: "heading" }, [
                      _c("strong", [_vm._v("Criada em")])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "title is-6" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("date")(
                            _vm.quotation.created,
                            "DD/MM/YYYY HH:mm"
                          )
                        )
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "level-item has-text-centered page-quotation__header-item"
                },
                [
                  _c("div", [
                    _c("p", { staticClass: "heading" }, [
                      _c("strong", [_vm._v("Plataforma")])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "title is-6" }, [
                      _vm._v(_vm._s(_vm.quotation.platform))
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "level-item has-text-centered" }, [
                _c("div", [
                  _c("p", { staticClass: "field" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button is-primary is-fullwidth",
                        attrs: { href: "/ng#/create-order/" + _vm.quotation.id }
                      },
                      [_vm._v("\n              Criar pedido\n            ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "field" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button is-warning is-fullwidth",
                        attrs: { href: "/ng#/quote/volume/requote/" }
                      },
                      [_vm._v("\n              Cotar novamente\n            ")]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.quotation.order && _vm.quotation.order.volumes.length > 0
              ? _c("div", [
                  _c(
                    "h2",
                    {
                      staticClass:
                        "subtitle has-text-weight-bold has-text-primary is-size-4"
                    },
                    [
                      _vm._v(
                        "\n        Volumes (" +
                          _vm._s(_vm.quotation.order.volumes.length) +
                          ")\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "columns" },
                    _vm._l(_vm.quotation.order.volumes, function(
                      volume,
                      volumeKey
                    ) {
                      return _c(
                        "div",
                        { key: volumeKey, staticClass: "column is-4" },
                        [
                          _c(
                            "sc-card",
                            [
                              _c(
                                "template",
                                { attrs: { slot: "header" }, slot: "header" },
                                [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "has-text-primary is-size-6 card-header-title"
                                    },
                                    [_vm._v("Volume " + _vm._s(volumeKey + 1))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "template",
                                { attrs: { slot: "body" }, slot: "body" },
                                [
                                  volume.type
                                    ? _c("p", { staticClass: "heading" }, [
                                        _c("strong", [
                                          _vm._v("Tipo de volume:")
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(volume.type.label))
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  volume.type
                                    ? _c("p", { staticClass: "heading" }, [
                                        _c("strong", [
                                          _vm._v("Custo dos produtos:")
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("currency")(
                                                volume.cost_of_goods
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  volume.weight
                                    ? _c("p", { staticClass: "heading" }, [
                                        _c("strong", [_vm._v("Peso:")]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("weight")(volume.weight)
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  volume.height && volume.width && volume.length
                                    ? _c("p", { staticClass: "heading" }, [
                                        _c("strong", [_vm._v("Dimensões:")]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(volume.height) +
                                              " x " +
                                              _vm._s(volume.width) +
                                              " x " +
                                              _vm._s(volume.length) +
                                              " cm"
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    })
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _vm.quotation.logistic_provider &&
            _vm.quotation.logistic_provider.delivery_methods.length > 0
              ? _c("div", [
                  _c(
                    "h2",
                    {
                      staticClass:
                        "subtitle has-text-weight-bold has-text-primary is-size-4"
                    },
                    [
                      _vm._v(
                        "\n        Opções de Envio (" +
                          _vm._s(
                            _vm.quotation.logistic_provider.delivery_methods
                              .length
                          ) +
                          ")\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "columns",
                      staticStyle: { "flex-flow": "row wrap" }
                    },
                    _vm._l(
                      _vm.quotation.logistic_provider.delivery_methods,
                      function(deliveryMethod, deliveryMethodKey) {
                        return _c(
                          "div",
                          {
                            key: deliveryMethodKey,
                            staticClass: "column is-4"
                          },
                          [
                            _c(
                              "sc-card",
                              [
                                _c(
                                  "template",
                                  { attrs: { slot: "header" }, slot: "header" },
                                  [
                                    _vm.isRemovedBy(deliveryMethod)
                                      ? _c(
                                          "sc-tooltip",
                                          {
                                            attrs: {
                                              label: _vm.tooltipLabel(
                                                deliveryMethod
                                              ),
                                              type: "is-dark",
                                              animated: ""
                                            }
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                class: {
                                                  "has-text-primary is-size-6 card-header-title has-text-line-through": _vm.isRemovedBy(
                                                    deliveryMethod
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      deliveryMethod.name
                                                    ) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _c(
                                          "p",
                                          {
                                            staticClass:
                                              "has-text-primary is-size-6 card-header-title"
                                          },
                                          [_vm._v(_vm._s(deliveryMethod.name))]
                                        )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "template",
                                  { attrs: { slot: "body" }, slot: "body" },
                                  [
                                    _c("div", { staticClass: "columns" }, [
                                      _c("div", { staticClass: "column" }, [
                                        deliveryMethod.name
                                          ? _c(
                                              "p",
                                              { staticClass: "heading" },
                                              [
                                                _c("strong", [
                                                  _vm._v("Método de envio:")
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(deliveryMethod.name)
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        deliveryMethod.description
                                          ? _c(
                                              "p",
                                              { staticClass: "heading" },
                                              [
                                                _c("strong", [
                                                  _vm._v("Nome exibido:")
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      deliveryMethod.description
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        deliveryMethod.type
                                          ? _c(
                                              "p",
                                              { staticClass: "heading" },
                                              [
                                                _c("strong", [
                                                  _vm._v("Tipo de Método:")
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      deliveryMethod.type.label
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        deliveryMethod.final_shipping_cost
                                          ? _c(
                                              "p",
                                              { staticClass: "heading" },
                                              [
                                                _c("strong", [
                                                  _vm._v("Frete exibido:")
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        deliveryMethod.final_shipping_cost
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        deliveryMethod.delivery_estimate_minutes ||
                                        deliveryMethod.delivery_estimate_business_days
                                          ? _c(
                                              "p",
                                              { staticClass: "heading" },
                                              [
                                                _c("strong", [
                                                  _vm._v("Prazo de entrega:")
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      deliveryMethod.delivery_estimate_minutes
                                                        ? deliveryMethod.delivery_estimate_minutes +
                                                            " minuto(s)"
                                                        : deliveryMethod.delivery_estimate_business_days +
                                                            " dia(s)"
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        deliveryMethod.delivery_estimate_date_minutes_iso
                                          ? _c(
                                              "p",
                                              { staticClass: "heading" },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    "Data prevista da entrega:"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .Moment(
                                                          deliveryMethod.delivery_estimate_date_minutes_iso
                                                        )
                                                        .format("L") +
                                                        " ÀS " +
                                                        _vm
                                                          .Moment(
                                                            deliveryMethod.delivery_estimate_date_minutes_iso
                                                          )
                                                          .format("LT")
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        deliveryMethod.cost
                                          ? _c(
                                              "p",
                                              { staticClass: "heading" },
                                              [
                                                _c("strong", [
                                                  _vm._v("Custo de envio:")
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        deliveryMethod.cost
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "column is-narrow" },
                                        [
                                          _c(
                                            "figure",
                                            { staticClass: "image is-128x128" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: deliveryMethod.logo_url,
                                                  alt: deliveryMethod.name
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "button is-primary",
                                              attrs: { target: "_blank" },
                                              on: {
                                                click: function($event) {
                                                  _vm.openQuotingDetailRecote(
                                                    _vm.quotation,
                                                    deliveryMethod,
                                                    _vm.backUrl
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Cotação Detalhada\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      }
                    )
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _vm.quotation.delivery_options_debug &&
            _vm.quotation.delivery_options_debug.length > 0
              ? _c("div", [
                  _c(
                    "h2",
                    {
                      staticClass:
                        "subtitle has-text-weight-bold has-text-primary is-size-4"
                    },
                    [
                      _vm._v(
                        "\n          Opções de Envio Não Disponíveis (" +
                          _vm._s(_vm.quotation.delivery_options_debug.length) +
                          ")\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "columns",
                      staticStyle: { "flex-flow": "row wrap" }
                    },
                    _vm._l(_vm.quotation.delivery_options_debug, function(
                      excludedMethod,
                      excludedMethodKey
                    ) {
                      return _c(
                        "div",
                        { key: excludedMethodKey, staticClass: "column is-4" },
                        [
                          _c(
                            "sc-card",
                            [
                              _c(
                                "template",
                                { attrs: { slot: "header" }, slot: "header" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "has-text-primary is-size-6 card-header-title"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(excludedMethod.name) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "template",
                                { attrs: { slot: "body" }, slot: "body" },
                                [
                                  _c("div", { staticClass: "columns" }, [
                                    _c(
                                      "div",
                                      { staticClass: "column" },
                                      [
                                        _vm._l(
                                          excludedMethod.restriction_messages,
                                          function(item, index) {
                                            return _c(
                                              "p",
                                              {
                                                key: index,
                                                staticClass: "heading"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(item) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        _vm._v(" "),
                                        excludedMethod.name
                                          ? _c(
                                              "p",
                                              { staticClass: "heading" },
                                              [
                                                _c("strong", [
                                                  _vm._v("Método de envio:")
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(excludedMethod.name)
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        excludedMethod.delivery_method_type
                                          ? _c(
                                              "p",
                                              { staticClass: "heading" },
                                              [
                                                _c("strong", [
                                                  _vm._v("Tipo de Método:")
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      excludedMethod
                                                        .delivery_method_type
                                                        .label
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        excludedMethod.final_shipping_cost
                                          ? _c(
                                              "p",
                                              { staticClass: "heading" },
                                              [
                                                _c("strong", [
                                                  _vm._v("Frete exibido:")
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        excludedMethod.final_shipping_cost
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        excludedMethod.delivery_estimate_business_days ||
                                        excludedMethod.freight
                                          .delivery_estimate_minutes
                                          ? _c(
                                              "p",
                                              { staticClass: "heading" },
                                              [
                                                _c("strong", [
                                                  _vm._v("Prazo de entrega:")
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.deliveryTimeDescrption(
                                                        excludedMethod
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        excludedMethod.freight
                                          .delivery_estimate_date_minutes_iso
                                          ? _c(
                                              "p",
                                              { staticClass: "heading" },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    "Data prevista da entrega:"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .Moment(
                                                          excludedMethod.freight
                                                            .delivery_estimate_date_minutes_iso
                                                        )
                                                        .format("L") +
                                                        " ÀS " +
                                                        _vm
                                                          .Moment(
                                                            excludedMethod
                                                              .freight
                                                              .delivery_estimate_date_minutes_iso
                                                          )
                                                          .format("LT")
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        excludedMethod.cost
                                          ? _c(
                                              "p",
                                              { staticClass: "heading" },
                                              [
                                                _c("strong", [
                                                  _vm._v("Custo de envio:")
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        excludedMethod.cost
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ])
                                ]
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    })
                  )
                ])
              : _vm._e()
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cf0b3ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cf0b3ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/quotations/pages/quotation/PageQuotation.vue
// module id = null
// module chunks = 